import { NumberFieldWithFlexibility } from '~/components/common/form/NumberFieldWithFlexibility/NumberFieldWithFlexibility';

/**
 * Ask for how many people are in the wedding party as the 'serviceCustomerCount'.
 * This is used for beauticians.  For florists, we ask for wedding party count.
 *
 * @returns
 */
export const ServiceCustomerField = () => (
  <NumberFieldWithFlexibility
    placeholder="Enter a number"
    name="serviceCustomerCount"
    maxValue={200}
    required
    flexibleFieldName="flexibleOnServiceCustomerCount"
  />
);
